"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.avatar.list': 'Avatar',
    'route.avatar.create': 'Aggiungi Avatar',
    'route.avatar.edit': 'Modifica Avatar',
    'route.avatar.preview': 'Anteprima Avatar',
};
